/* eslint-disable react/jsx-one-expression-per-line */
import { ReactElement } from 'react';
import { useFormikContext } from 'formik';
// import { FormLoading } from '@components';
import { iExtensionFormValues } from '@services/ExtensionService';

import gridStyle from '@pages/forms/Grid.module.scss';
import styles from './ExtensionStep15.module.scss';

function ExtensionStep15(): ReactElement {
  const { values }: { values: iExtensionFormValues } = useFormikContext();
  return (
    <>
      <div className={gridStyle.form}>
        <div className="vfH2">You can also apply by phone</div>
        <div className="subHeadingH3">If this is your first extension, your application can also be completed through our phone system, without needing to speak to someone.</div>
        {values.IsESIorDDD && (
        <p>
          Because you have a fine that was issued for
          {values.DDD && (<span> a drunk or drug driving offence</span>)}
          {values.ESI && (<span> an excessive speed</span>)}
          {values.MarineOffence && (<span> a drink or drug-boating</span>)}, it's important you know that this will not extend your licence cancellation date. This application only relates to your payment due date.
        </p>
        )}

        {values.isInitialOrReminderStatus && (
        <p className={styles.numberSize}>
          Call Fines Victoria: <a href="tel:+61392008111">(03) 9200 8111</a> or <a href="tel:1300369819">1300 369 819</a> (for regional callers)
        </p>
        )}
        {values.isEOIW && (
        <p className={styles.numberSize}>
          Call Fines Victoria: <a href="tel:+61392008111">(03) 9200 8222</a> or <a href="tel:1800150410">1800 150 410</a> (for regional callers)
        </p>
       )}

        <p>Select option 4, and follow the prompts. You will need to enter your obligation number <strong>{values.OBLIGATION_NUMBER}</strong> when you call.</p>

        <hr style={{ borderColor: '#3c3c3c' }} />
        <p>Click continue to apply online.</p>
      </div>
    </>
  );
}

export default ExtensionStep15;
